import React, { useCallback, useEffect } from 'react';
import { companyTypeInput } from '../data/searchFlowText';
import { useSelector, useDispatch } from 'react-redux';
import Navigation from '../components/navigation/navigation';
import { useNavigate } from 'react-router-dom';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import axios from '../../../shared/axios/axiosProxy';
import ACTIONS from '../../../redux/action';
import RadioInput from '../components/searchInputs/radioInput';

const CompanyType = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	const dispatch = useDispatch();

	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	const handleNext = useCallback(
		(e) => {
			props.handleNext(e);
		},
		[props]
	);

	const handleCompanyTypeChange = (value) => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'companytype',
				data: value,
				stateObject: 'company_store',
			})
		);
	};

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">{i18n.t('company.companyform')}</span>{' '}
					<span className="questionTracker">1/8</span>
				</p>
				<RadioInput
					storeID="companytype"
					dataText={companyTypeInput()}
					onChange={handleCompanyTypeChange}
				/>

				{/* {companyError ? (
          <span style={{ color: 'red', fontSize: '12px', fontWeight: 'bold' }}>
            {i18n.t('searchflow.choosetocontinue')}
          </span>
        ) : null} */}
			</div>
			<Navigation
				step={1}
				handleBack={() => handleBack()}
				handleNext={() => {
					if (companyStore.companytype === 'bt') {
						handleNext(1);
					} else {
						handleNext(2);
					}
				}}
				openHelpForm={() => props.openHelpForm()}
				disabledProp={companyStore.companytype === '' ? true : false}
			/>
		</div>
	);
};

export default withTranslation()(CompanyType);
